import angular from 'angular';

export default angular.module('books.data.ledgerItemOption', [])
  .factory('LedgerItemOption', ledgerItemOptionFactory)
  .name;

ledgerItemOptionFactory.$inject = [];

/** LedgerItemOption Constructor reference. */
/* @ngInject */ function ledgerItemOptionFactory() {
  /*****************************************************************************
   * Constructor */
  /**
   * Sets properties from given itemOption source if provided.
   *
   * @param itemOption  ItemOption source
   *****************************************************************************/
  function LedgerItemOption(itemOption) {
    var ioSrc = itemOption || {};
    this.itemID = ioSrc.itemID;
    this.optionMasterID = ioSrc.optionID || NaN;
    this.optionMasterName = ioSrc.optionName || null;
    this.itemOptionID = ioSrc.id || NaN;
    this.optionValue = ioSrc.value || null;
    this.priceChange = ioSrc.priceChange || 0.0;
    this.qtyChange = ioSrc.qtyChange || 0;
  }

  return LedgerItemOption;
}
